import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetDataFlowOrganizationsConvertersResData } from "./GetDataFlowOrganizationsConvertersResData";

const ENDPOINT = "/dataflow/converters";

export class GetDataFlowOrganizationsConvertersCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetDataFlowOrganizationsConvertersReqData = null;

    constructor(includeRoles: boolean) {
        super();
        this.params = new GetDataFlowOrganizationsConvertersReqData(includeRoles);
    }

    public async execute(): Promise<GetDataFlowOrganizationsConvertersResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetDataFlowOrganizationsConvertersResData(res);
    }
}

class GetDataFlowOrganizationsConvertersReqData {
    includeRoles: boolean;

    constructor(includeRoles: boolean) {
        this.includeRoles = includeRoles;
    }
}
